import _ from 'lodash';
import {
  GET_ITEMS,
  GET_ITEMS_FAIL,
  GET_ITEMS_SUCCESS,
  UPDATE_ITEM,
  UPDATE_ITEM_FAIL,
  UPDATE_ITEM_SUCCESS,
  DELETE_ITEM,
  DELETE_ITEM_FAIL,
  DELETE_ITEM_SUCCESS,
  SET_ITEM,
  CLEAR_ITEM,
  GET_ITEM_DETAIL_SUCCESS,
  GET_ITEM_DETAIL_FAIL,
  SHARE_ITEM,
  SHARE_ITEM_SUCCESS,
  UPDATE_SHORT_URL_SUCCESS,
  GET_UPDATED_ITEMS,
  GET_DELETED_ITEMS,
  GET_ITEM_DETAIL,
  SET_LOADING,
  GET_IMPORT_HISTORY_SUCCESS,
  CREATE_IMPORT_HISTORY_SUCCESS,
  UPDATE_HISTORY_STATUS_SUCCESS,
  DELETE_IMPORT_HISTORY_SUCCESS,
  UPDATE_FILTERED_ITEMS,
  REMOVE_TAG_FROM_ITEM,
  ADD_TAG_TO_ITEM,
  UPVOTE_ITEM,
  DELETE_UPVOTE_ITEM
} from "../actions/items";

import {
  USER_LOGOUT
} from "../actions/auth";

const sortValue = (a, b) => {
  if (a > b) {
    return 1;
  } else if (a === b) {
    return 0;
  }

  return -1;
}

// const initialState = {
//   isLoading: false,
//   items: [],
//   error: null,
//   itemDetail: [],
//   importHistory: []
// };

const initialState = {
  itemDetail: [],
  filtered: []
};

const ItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    // case 'persist/REHYDRATE':
    //   return state; // Force 'item' to be cleared on rehydrate
    case GET_ITEMS:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case GET_ITEMS_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        items: []
      };
    case GET_ITEMS_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        items: action.items
      };
    case UPDATE_FILTERED_ITEMS:
      return {
        ...state,
        filtered: [ ...action.items ]
      }
    case SHARE_ITEM:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case SHARE_ITEM_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        shortInfo: action.shortInfo
      };
    case UPDATE_ITEM: {
      const itemDetail = (state.itemDetail || []).filter(it => !_.isEmpty(it));

      const newItemDetail = itemDetail.map(item => {
        if (!_.isEmpty(action.newDetails) && item.id === action.newDetails.id) {
          let newDetails = JSON.stringify(action.newDetails);
          newDetails = JSON.parse(newDetails.replaceAll('__blank__', ''));

          return {
            ...item,
            ...newDetails,
            meta: {
              ...item.meta,
              ...(newDetails.meta || {})
            }
          }
        }

        return item;
      });

      return {
        ...state,
        error: null,
        isLoading: true,
        itemDetail: [ ...newItemDetail ]
      };
    }
    case UPDATE_ITEM_FAIL: {
      const itemDetail = (state.itemDetail || []).filter(it => !_.isEmpty(it));

      const newItemDetail = itemDetail.map(item => {
        if (!_.isEmpty(action.newDetails) && item.id === action.itemId) {
          const originItem = state.items.find(sit => sit.id === action.itemId);

          if (originItem) {
            return { ...originItem };
          }
        }

        return item;
      });

      return {
        ...state,
        error: action.error,
        isLoading: false,
        itemDetail: [ ...newItemDetail ]
      };
    }
    case UPVOTE_ITEM:
    case DELETE_UPVOTE_ITEM:
    case ADD_TAG_TO_ITEM:
    case REMOVE_TAG_FROM_ITEM: {
      return {
        ...state,
        error: null,
        isLoading: true
      }
    }
    case UPDATE_ITEM_SUCCESS: {
      const items = state.items || [];
      const newItems = items.map(item => {
        if (item.id === action.item.id) {
          return {
            ...item,
            ...action.item,
            meta: {
              ...item.meta,
              ...(action.item.meta || {})
            }
          }
        }  else {
          return item;
        }
      });

      return {
        ...state,
        error: null,
        isLoading: false,
        items: newItems
      };
    }
    case DELETE_ITEM:
      return {
        ...state,
        isLoading: true,
        error: null
      }
    case DELETE_ITEM_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case DELETE_ITEM_SUCCESS: {
      const items = state.items || [];
      const newItems = items.filter(item => item.id !== action.id);
      return {
        ...state,
        isLoading: false,
        error: null,
        items: newItems
      }
    }
    case GET_UPDATED_ITEMS: {
      const items = [...(state.items || [])];
      // const itemDetail = (state.itemDetail || []).filter(it => !_.isEmpty(it));
      const { items: updatedItems } = action;

      updatedItems.forEach(it => {
        if (it.meta.contentTags) {
          const keys = Object.keys(it.meta.contentTags);

          let sortedContentTags = {};
          keys.sort(sortValue).forEach(key => {
            sortedContentTags[key] = it.meta.contentTags[key];
          });

          it.meta.contentTags = sortedContentTags;
        }

        const findIndex = items.findIndex(item => item.id === it.id);
        
        if (findIndex >= 0) {
          items[findIndex] = it;
        } else {
          items.push(it);
        }

        // const findIndex1 = itemDetail.findIndex(item => item.id === it.id);
        
        // if (findIndex1 >= 0 && !_.isEmpty(it)) {
        //   itemDetail[findIndex1] = it;
        // }
      });
      
      return {
        ...state,
        isLoading: false,
        error: null,
        items: [
          ...items
        ],
        // itemDetail: [
        //   ...itemDetail
        // ]
      }
    }
    case GET_DELETED_ITEMS: {
      const items = state.items || [];
      const { items: deletedItems } = action;

      const newItems = items.filter(it => !deletedItems.find(dit => dit.id === it.id));
      
      return {
        ...state,
        isLoading: false,
        error: null,
        items: newItems
      }
    }
    case SET_ITEM: {
      const items = state.items || [];
      const itemDetail = (state.itemDetail || []).filter(it => !_.isEmpty(it));
      const newItem = items.find(it => it.id === action.itemId);
      
      if (!_.isEmpty(newItem) && !itemDetail.find(it => it.id === newItem.id)) {
        itemDetail.push(newItem);
      }

      return {
        ...state,
        itemDetail: [ ...itemDetail ]
      }
    }
    case GET_ITEM_DETAIL: {
      return {
        ...state,
        isLoading: true
      }
    }
    case SET_LOADING: {
      return {
        ...state,
        isLoading: true
      }
    }
    case GET_ITEM_DETAIL_SUCCESS: {
      const itemDetail = (state.itemDetail || []).filter(it => !_.isEmpty(it));
      if (_.isEmpty(action.detail)) {
        return {
          ...state,
          isLoading: false
        }
      }

      const itemIndex = itemDetail.findIndex(it => it.id === action.detail.id);

      if (itemIndex >= 0) {
        itemDetail[itemIndex] = action.detail;
      } else {
        itemDetail.push(action.detail);
      }

      return {
        ...state,
        itemDetail: [ ...itemDetail ],
        isLoading: false
      }
    }
    case GET_ITEM_DETAIL_FAIL: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }
    case CLEAR_ITEM: {
      const { itemDetail } = state;

      // sometimes we can be trying to clear and itemDetail isn't in scope
      // eg on logout from detail page
      let newItemDetails = itemDetail ? itemDetail.filter(it => !_.isEmpty(it) && it.id !== action.id) : [];

      return {
        ...state,
        itemDetail: [ ...newItemDetails ]
      }
    }
    case UPDATE_SHORT_URL_SUCCESS: {
      const itemDetail = (state.itemDetail || []).filter(it => !_.isEmpty(it));
      const items = state.items || [];

       const findIndex = itemDetail.findIndex(it => it.id === action.id);

       if (findIndex >= 0) {
        const updateItem = itemDetail[findIndex];

        const index = items.findIndex(item => item.id === updateItem.id);

        if (index >= 0) {
          items[index].urls.short = action.data.shortUrl;
          items[index].urls.target = action.data.targetUrl;
        }

        updateItem.urls.short = action.data.shortUrl;
        updateItem.urls.target = action.data.targetUrl;
        itemDetail[findIndex] = updateItem;
      }

      return {
        ...state,
        itemDetail: [ ...itemDetail ],
        items
      }
    }
    case GET_IMPORT_HISTORY_SUCCESS: {
      return {
        ...state,
        importHistory: action.histories
      }
    }
    case CREATE_IMPORT_HISTORY_SUCCESS: {
      const importHistory = state.importHistory || [];
      importHistory.push(action.historyData);

      return {
        ...state,
        importHistory: [...importHistory]
      }
    }
    case UPDATE_HISTORY_STATUS_SUCCESS: {
      const importHistory = state.importHistory || [];
      const index = importHistory.findIndex(history => history.importId === action.historyData.importId);
      if (index >= 0) {
        importHistory[index] = action.historyData;
      }

      return {
        ...state,
        importHistory: [...importHistory]
      }
    }
    case DELETE_IMPORT_HISTORY_SUCCESS: {
      const importHistory = state.importHistory || [];
      const index = importHistory.findIndex(history => history.importId === action.historyData.importId);
      if (index >= 0) {
        importHistory[index].status = action.historyData.status;
      }

      return {
        ...state,
        importHistory: [...importHistory]
      }
    }
    case USER_LOGOUT: {
      return {};
    }
    default:
      return state;
  }
}

export default ItemsReducer;
